import * as Yup from "yup";
import { getInitialValues } from "layouts/views/common/common";

const formField = {
  skuCode: {
    name: "skuCode",
    label: "SKU Code",
    type: "select",
    errorMsg: "SKU code is required.",
    required: true,
    editable: false,
  },
  vendorCode: {
    name: "vendorCode",
    label: "Vendor Code",
    type: "select",
    errorMsg: "Vendor code is required.",
    required: true,
    editable: false,
  },
  vendorSKU: {
    name: "vendorSKU",
    label: "Vendor SKU",
    type: "text",
    errorMsg: "Vendor SKU is required.",
    required: true,
    editable: false,
  },
  customerCode: {
    name: "customerCode",
    label: "Customer Code",
    //type: "select",
    type: "text",
    errorMsg: "Customer code is required.",
    required: true,
    disabled: true,
    //edit:true
  },
  manufacturerSKU: {
    name: "manufacturerSKU",
    label: "Manufacturer SKU",
    type: "text",
    //errorMsg: "SKU code is required.",
  },
  alternateSKU: {
    name: "alternateSKU",
    label: "Alternate SKU",
    type: "text",
    //errorMsg: "SKU code is required.",
  },
  defRecvWh: {
    name: "defRecvWh",
    label: "Warehouse",
    type: "select",
    errorMsg: "Default receiving warehouse is required.",
    required: true,
  },
  defRecvZone: {
    name: "defRecvZone",
    label: "Zone",
    type: "select",
    errorMsg: "Default receiving zone is required.",
    required: true,
  },
  defRecvLocation: {
    name: "defRecvLocation",
    label: "Location",
    type: "select",
    errorMsg: "Default receiving location is required.",
    required: true,
  },
  defPutawayWh: {
    name: "defPutawayWh",
    label: "Warehouse",
    type: "select",
    errorMsg: "Default putaway warehouse is required.",
    required: true,
  },
  defPutawayZone: {
    name: "defPutawayZone",
    label: "Zone",
    type: "select",
    errorMsg: "Default putaway zone is required.",
    required: true,
  },
  defPutawayLocation: {
    name: "defPutawayLocation",
    label: "Location",
    type: "select",
    //errorMsg: "Default putaway location is required.",
  },
  defTRPutawayWh: {
    name: "defTRPutawayWh",
    label: "Warehouse",
    type: "select",
    errorMsg: "Default trade return putaway warehouse is required.",
    required: true,
  },
  defTRPutawayZone: {
    name: "defTRPutawayZone",
    label: "Zone",
    type: "select",
    errorMsg: "Default trade return putaway zone is required.",
    required: true,
  },
  defTRPutawayLocation: {
    name: "defTRPutawayLocation",
    label: "Location",
    type: "select",
    errorMsg: "Default trade return putaway location is required.",
    required: true,
  },
  defShipWh: {
    name: "defShipWh",
    label: "Warehouse",
    type: "select",
    errorMsg: "Default shipping warehouse is required.",
    required: true,
  },
  defShipZone: {
    name: "defShipZone",
    label: "Zone",
    type: "select",
    errorMsg: "Default shipping zone is required.",
    required: true,
  },
  defShipLocation: {
    name: "defShipLocation",
    label: "Location",
    type: "select",
    errorMsg: "Default shipping location is required.",
    required: true,
  },
};

const {
  skuCode,
  vendorCode,
  vendorSKU,
  customerCode,
  manufacturerSKU,
  alternateSKU,
  defRecvWh,
  defRecvZone,
  defRecvLocation,
  defPutawayWh,
  defPutawayZone,
  defPutawayLocation,
  defTRPutawayWh,
  defTRPutawayZone,
  defTRPutawayLocation,
  defShipWh,
  defShipZone,
  defShipLocation,
} = formField;

export const form = {
  formId: "add-vendor-sku-form",
  formField,
  formRender: [
    [skuCode, customerCode],
    [vendorCode, manufacturerSKU],
    [vendorSKU, alternateSKU],
    [
      { type: "title", label: "Default Receiving" },
      { type: "title", label: "Default Trade Return Putaway" },
    ],
    [defRecvWh, defTRPutawayWh],
    [defRecvZone, defTRPutawayZone],
    [defRecvLocation, defTRPutawayLocation],
    [
      { type: "title", label: "Default Putaway" },
      { type: "title", label: "Default Shipping" },
    ],
    [defPutawayWh, defShipWh],
    [defPutawayZone, defShipZone],
    [defPutawayLocation, defShipLocation],
  ],
};

export const formRender = [
  [skuCode, vendorCode, vendorSKU, customerCode],
  [manufacturerSKU, alternateSKU],
  [
    { type: "title", label: "Default Receiving" },
    { type: "title", label: "Default Putaway" },
    { type: "title", label: "Default Trade Return Putaway" },
    { type: "title", label: "Default Shipping" },
  ],
  [defRecvWh, defPutawayWh, defTRPutawayWh, defShipWh],
  [defRecvZone, defPutawayZone, defTRPutawayZone, defShipZone],
  [defRecvLocation, defPutawayLocation, defTRPutawayLocation, defShipLocation],
];

export const initialValues = getInitialValues(formField);

export const vendorSKUValidation = Yup.object().shape({
  [skuCode.name]: Yup.string().nullable().max(50).required(skuCode.errorMsg),
  [vendorCode.name]: Yup.string().nullable().max(20).required(vendorCode.errorMsg),
  [vendorSKU.name]: Yup.string().nullable().max(20).required(vendorSKU.errorMsg),
  [customerCode.name]: Yup.string().nullable().max(20).required(customerCode.errorMsg),
  [manufacturerSKU.name]: Yup.string().nullable().max(50),
  [alternateSKU.name]: Yup.string().nullable().max(50),
  [defRecvWh.name]: Yup.string().nullable().max(20).required(defRecvWh.errorMsg),
  [defRecvZone.name]: Yup.string().nullable().max(20).required(defRecvZone.errorMsg),
  [defRecvLocation.name]: Yup.string().nullable().max(20).required(defRecvLocation.errorMsg),
  [defPutawayWh.name]: Yup.string().nullable().max(20).required(defPutawayWh.errorMsg),
  [defPutawayZone.name]: Yup.string().nullable().max(20).required(defPutawayZone.errorMsg),
  [defPutawayLocation.name]: Yup.string().nullable().max(20),
  [defTRPutawayWh.name]: Yup.string().nullable().max(20).required(defTRPutawayWh.errorMsg),
  [defTRPutawayZone.name]: Yup.string().nullable().max(20).required(defTRPutawayZone.errorMsg),
  [defTRPutawayLocation.name]: Yup.string()
    .nullable()
    .max(20)
    .required(defTRPutawayLocation.errorMsg),
  [defShipWh.name]: Yup.string().nullable().max(20).required(defShipWh.errorMsg),
  [defShipZone.name]: Yup.string().nullable().max(20).required(defShipZone.errorMsg),
  [defShipLocation.name]: Yup.string().nullable().max(20).required(defShipLocation.errorMsg),
});
